import flattenContestRounds from './flattenContestRounds';

export default (contest) => {
  return {
      ...contest,
      rounds: flattenContestRounds(contest),
  };
};



// WEBPACK FOOTER //
// ./src/utils/getContestWithFlattenedRounds.js